import AppWeb from "../../../component/platform/AppWeb";
import {ComponentRegistryProvider} from "../../context/componentRegistry/ComponentRegistryContext";
import TabNavigator from "../../../navigation/mobile/tabNavigator/TabNavigator";
import './mobile-app.css'
import AlwaysRememberMe from "../../../component/auth/AlwaysRememberMe";
import ProductQuantityInputButton from "../../../component/product/ProductQuantityInputButton";
import {Keyboard} from "@capacitor/keyboard";
import {useEffect} from "react";
import Platform from "../../../logic/platform/platform";

function resetViewportZoom() {
    const metaViewport = document.querySelector('meta[name=viewport]');
    if (metaViewport) {
        metaViewport.setAttribute(
            'content',
            'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
        );
        // Restore default after delay
        setTimeout(() => {
            metaViewport.setAttribute(
                'content',
                'width=device-width, initial-scale=1'
            );
        }, 300);
    }
}

const AppMobile = () => {

    useEffect(() => {
        const listener = Keyboard.addListener('keyboardDidHide', () => {
            if(Platform.isIos()) resetViewportZoom();
        });
        return () => { listener.remove(); };
    }, []);

    return (
        <>
            <div className="mobile-test"/>
            <div className="mobile-app">
                <ComponentRegistryProvider
                    components={{
                        "footer": TabNavigator,
                        "rememberMe": AlwaysRememberMe,
                        "productQuantityInput": ProductQuantityInputButton
                    }}
                >
                    <AppWeb/>
                </ComponentRegistryProvider>
            </div>
        </>
    )

}

export default AppMobile;
